import { awsSecretsManagerSubRouteRef, rootRouteRef } from './routes';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

export const awsServicesPlugin = createPlugin({
  id: 'aws-services',
  routes: {
    root: rootRouteRef,
    secretsManager: awsSecretsManagerSubRouteRef,
  },
});

export const AwsSecretsManagerPage = awsServicesPlugin.provide(
  createRoutableExtension({
    name: 'AwsSecretsManagerContentTab',
    component: () =>
      import('./components/SecretsManager/SecretsManagerComponent').then(
        m => m.SecretsManagerComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
